import ExchangeDataProvider from "@pionex-web-kit/common-business/es/trade/ExchangeDataProvider";
export default ExchangeDataProvider;